<template>
  <div class="text-center not-found-container">
    <i class="ti ti-4x ti-warning" />
    <h1>Désolé,</h1>
    <p>La page que vous avez demandée n'existe pas</p>
    <router-link :to="{ name: 'home' }">Retour à la page d'accueil</router-link>
  </div>
</template>

<script>
  export default {
    name: 'NotFoundPage',
  };
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/NotFound.vue